export default {
	props: {
		isOpen: {
			type:    Boolean,
			default: false,
		},
		menuItems: {
			type:    Array,
			default: () => [],
		},
		title: {
			type: String,
		},
		contextData: {
			required: false,
		},
		blocking: {
			type:    Boolean,
			default: true,
		},
		selected: {
			default: null,
		},
		hideIcon: {
			type:    Boolean,
			default: false,
		},
	},
	methods: {
		handleItemClick(item) {
			this.$emit('item-click', item.id, item.action, this.contextData);
		},
		isSelected(itemId) {
			return this.selected === itemId;
		},
	},
};
